module.exports = __webpack_public_path__ + "img/pasta_a_la_vodka.37803d92.jpg";